<template>
    <div style="padding-bottom:180px;">

        <h1 class="mt-4">Prospects<a href="/clinics/new" class="btn btn-primary btn-sm ms-6">Lägg till prospect</a></h1>

        <div class="content-container">

            <div class="row g-6 mb-4">

                <div class="col-24 col-md-4">
                    <input
                        type="text"
                        class="form-control new-list-group-field"
                        placeholder="Sök namn, adress, e-post, telefon..."
                        v-model="settings.query.text"
                    >
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.status">
                        <option :value="null">Status</option>
                        <option value="1">Prospect</option>
                        <option value="6">Avslutat prospect</option>
                        <option value="7">Inaktivt prospect</option>
                    </select>
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.prospect_manager">
                        <option :value="null">Ansvarig</option>
                        <option v-for="user in options.users" :key="'pm_'+user.id" :value="user.id">
                            {{ user.name }}
                        </option>
                    </select>
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.next_contact">
                        <option :value="null">Nästa kontakt</option>
                        <option v-for="user in options.users" :key="'nc_'+user.id" :value="user.id">
                            {{ user.name }}
                        </option>
                    </select>
                </div>

                <div class="col-24 col-md-3">
                    <select class="form-select new-list-group-field" v-model="settings.query.prospect_product_area">
                        <option :value="null">Tjänst</option>
                        <option v-for="area in options.product_areas" :key="'pa_'+area.id" :value="area.id">
                            {{ area.name }}
                        </option>
                    </select>
                </div>

                <div class="col-24 col-md-5">
                    <select class="form-select new-list-group-field" v-model="settings.query.last_contact_type">
                        <option :value="null">Senaste händelse</option>
                        <optgroup v-for="(group, groupName) in options.contact_log_types" :key="groupName" :label="groupName">
                            <option v-for="item in group.items" :key="item.handle" :value="item.handle">{{ item.label }}</option>
                        </optgroup>
                    </select>
                </div>

                <div class="col-24 col-md-3 d-flex justify-content-end">
                    <button class="btn btn-primary btn-sm" @click="openExportModal()">Spara Excel
                        <div class="tooltip-label">Ladda ner en Excel-fil med mottagningar.</div>
                    </button>
                </div>

            </div>

            <list ref="list" :settings="settings" :query.sync="settings.query">
                <div slot="item-row" slot-scope="props">
                    <div class="row g-3">
                        <div class="col d-none d-md-flex col-md-1">
                            <span>{{ props.item.id }}</span>
                        </div>
                        <div class="col col-12 col-md-4">
                            <span>{{ props.item.name_person }}</span>
                            <span class="badge badge-secondary ms-2" v-if="props.item.select_prospect_source == 4">Intresse</span>
                        </div>
                        <div class="col d-none d-lg-flex col-lg-3">
                            <span>{{ props.item.group }}</span>
                        </div>
                        <div class="col d-none d-lg-flex col-lg-5" style="cursor:pointer;" @click="openLog(props.item)">

                            <div class="tooltip-target h-100">
                                <div class="w-100 d-flex flex-row-reverse">
                                    <div v-for="(logg,index) in props.item.recent_contact_logs">
                                        <span class="badge badge-light-grey ms-0" :class="'message-'+message_type(logg.type,logg.contact_by_email,logg.contact_by_sms)">{{ logg.type_label }}</span>
                                        <span v-if="index != 0">-></span>
                                    </div>
                                </div>
                                <div class="tooltip-label tooltip-label-xxl tooltip-label-white py-3 px-0">
                                    
                                    <div class="container-fluid">
                                        <div class="row tooltip-logg-row" v-for="logg in props.item.recent_contact_logs">
                                            <div class="col-5 align-items-start" style="text-transform: capitalize;">{{ formatDate(logg.contacted_at) }}</div>
                                            <div class="col-4 d-block">
                                                <span style="font-weight:400;">{{ logg.type_label }}</span>
                                                <span class="badge badge-light-grey ms-0" v-if="logg.contact_by_email == 1">Mejl</span>
                                                <span class="badge badge-light-grey ms-0" v-if="logg.contact_by_sms == 1">SMS</span>
                                            </div>
                                            <div class="col-15 d-block">
                                                <div v-if="logg.contact_by_email == 1" style="margin-bottom:8px;">
                                                    <span>Ämne: {{ logg.email_subject }}</span>
                                                </div>
                                                <div v-if="logg.contact_by_email == 1" class="logg-message" :class="message_type(logg.type,logg.contact_by_email,logg.contact_by_sms)" v-html="formatComment(logg.email_message)"></div>
                                                <div v-if="logg.contact_by_sms == 1" class="logg-message" :class="message_type(logg.type,logg.contact_by_email,logg.contact_by_sms)" v-html="formatComment(logg.sms_message)"></div>
                                                <div v-html="formatComment(logg.comment)"></div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                        <div class="col d-none d-lg-flex col-lg-3">
                            <span>{{ props.item.prospect_manager }}</span>
                        </div>
                        <div class="col d-none d-lg-flex col-lg-2">
                            <span>{{ props.item.meta_next_contact }}</span>
                        </div>
                        <div class="col d-none d-lg-flex col-lg-2">
                            <span>{{ props.item.product_area_name }}</span>
                        </div>
                        <div class="col d-none d-md-flex col-md-2">
                            <span class="badge badge-primary ms-0" v-if="props.item.status_label === 'Aktiv'">{{ props.item.status_label }}</span>
                            <span class="badge badge-warning ms-0" v-else-if="props.item.status_label === 'Prospekt'">{{ props.item.status_label }}</span>
                            <span class="badge badge-danger ms-0" v-else-if="props.item.status_label === 'Avslutad' || props.item.status_label === 'Avslutat prospekt'">{{ props.item.status_label }}</span>
                            <span class="badge badge-info ms-0" v-else>{{ props.item.status_label }}</span>
                        </div>
                        <div class="col col-12 col-md-2 d-flex justify-content-end">
                            <a :href="'/clinics/'+props.item.id">
                                <button class="btn btn-primary btn-sm">Hantera</button>
                            </a>
                        </div>
                    </div>
                </div>
            </list>

        </div>
    </div>
</template>

<script>
import lister from '../../../shared/mixins/lister'

export default {

    mixins: [
        lister
    ],

    props: {
        options: {
            required: true
        }
    },

    data () {
        return {
            settings: {
                url: '/prospects/list',
                query: {
                    text: '',
                    status: null,
                    prospect_manager: null,
                    prospect_product_area: null,
                    next_contact: null,
                    last_contact_type: null,
                },
                columns: [
                    { column: 'id', name: 'ID', class: 'col d-none d-md-flex col-md-1', sortable: true, default: true },
                    { column: 'name_person', name: 'Namn', class: 'col col-12 col-md-4', sortable: true },
                    { column: 'group', name: 'Område', class: 'col d-none d-lg-flex col-lg-3', sortable: true },
                    { column: 'recent_contact_log_date', name: 'Senaste händelser', class: 'col d-none d-lg-flex col-lg-5', sortable: true },
                    { column: 'prospect_manager', name: 'Ansvarig', class: 'col d-none d-lg-flex col-lg-3', sortable: true },
                    { column: 'meta_next_contact', name: 'Nästa k.', class: 'col d-none d-lg-flex col-lg-2', sortable: true },
                    { column: 'product_area_name', name: 'Tjänst', class: 'col d-none d-lg-flex col-lg-2', sortable: true },
                    { column: 'status_label', name: 'Status', class: 'col d-none d-md-flex col-md-2', sortable: false },
                ],
                bulk_actions: [],
                export_fields: [
                    { column: 'id', name: 'ID' },
                    { column: 'name_person', name: 'Namn' },
                    { column: 'name_clinic', name: 'Kliniknamn' },
                    { column: 'name_company', name: 'Företagsnamn' },
                    { column: 'email', name: 'E-post' },
                    { column: 'billing_phone', name: 'Telefon' },
                    { column: 'group', name: 'Område' },
                    { column: 'prospect_manager', name: 'Ansvarig' },
                    { column: 'meta_next_contact', name: 'Nästa kontaktdatum' },
                    { column: 'product_area_name', name: 'Område' },
                    { column: 'status_label', name: 'Status' },
                    { column: 'created_at', name: 'Skapad' },
                ]
            }
        }
    },

    created () {
        moment.locale('sv')
    },

    methods: {
        formatDate(date) {
          const m = moment(date)
          const now = moment()
          const time = m.format('HH:mm')

          if (m.isSame(moment(), 'day')) {
            return `Idag ${time}`
          }

          if (m.isSame(moment().subtract(1, 'day'), 'day')) {
            return `Igår ${time}`
          }

          if (m.isSame(moment().add(1, 'day'), 'day')) {
            return `Imorgon ${time}`
          }

          const dateFormat = m.isSame(now, 'year') ? 'dddd D MMM' : 'dddd D MMM YYYY'

          return `${m.format(dateFormat)} ${time}`

        },
        formatComment(string){
            if(string != null && string.length > 200){
                return string.substr(0, 200)+"..."
            }
            return string
        },
        message_type(status,email,sms){
            if(status == 'inkommande-svar')
            {
                return 'in'
            }else if(status != 'inkommande-svar' && (email == 1 || sms == 1)){
                return 'out'
            }
            return ''
        },
        openLog (item) {
            window.location.href = '/clinics/' + item.id + '#form_log'
        }
    }
}
</script>
